/*eslint-disable*/
import React, { useState, useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Nav, Button } from "reactstrap";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

import logo from "JCWLogo-white.svg";
import axios from "axios";
import { api_link } from "siteConfig";

var ps;

function Sidebar(props) {

  const [contracts, setContracts] = useState([]);
  const [contractSites, setContractSites] = useState([]);
  const [isChangingContract, setIsChangingContract] = useState(false);

  const sidebar = React.useRef();
  const location = useLocation();
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };

  const loadContractsData = () => {
    // sessionStorage.setItem("contractsLoaded", "1");

    let url = 'https://' + api_link + 'customer_portal_v2/getContracts';

    return axios({
      method: "post",
      url: url,
      data: {
        "referurl": url
      },
      timeout: 5000,
      headers: {
        "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
        "Content-Type": "application/json"
      }
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        // Handle any errors that occur during the API request
      });
  };

  const loadContracts = async () => {
    try {
      let contractsData = await loadContractsData();
      setContracts(contractsData);
      sessionStorage.setItem("contractsLoaded", "1");
    } catch (error) {
      console.error("Error loading contracts:", error);
    }
  };


  const loadContractSitesData = (contract_id) => {

    // console.log("Loading Contract Sites");
    // sessionStorage.setItem("contractsLoaded", "1");

    let url = 'https://' + api_link + 'customer_portal_v2/getContractSites';

    return axios({
      method: "post",
      url: url,
      data: {
        "referurl": url,
        "var1": contract_id
      },
      timeout: 5000,
      headers: {
        "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
        "Content-Type": "application/json"
      }
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        // Handle any errors that occur during the API request
      });
  };

  const loadContractSites = async (contract_id) => {
    try {
      let contractSites = await loadContractSitesData(contract_id);
      // console.log(contractSites);
      setContractSites(contractSites);
      
      // Immediately update session storage with the new site IDs
      if (contractSites && contractSites.length > 0) {
        sessionStorage.setItem("site_ids", contractSites.join(","));
      }
      
      return contractSites;
    } catch (error) {
      console.error("Error loading contract sites:", error);
      return [];
    }
  };



  const loadStatsData = (sites) => {
    let url = 'https://' + api_link + 'customer_portal_v2/getStats';

    return axios({
      method: "post",
      url: url,
      data: {
        "referurl": url,
        "var1": sites
      },
      timeout: 5000,
      headers: {
        "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
        "Content-Type": "application/json"
      }
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        // Handle any errors that occur during the API request
      });
  }

  const loadStats = (siteIds) => {
    loadStatsData(siteIds)
      .then(statsData => {
        // Stats will be handled by the Dashboard component
        // Just trigger a refresh by updating session storage flags
        sessionStorage.setItem("statsLoaded", "0");
        sessionStorage.setItem("contactsLoaded", "0");
      });
  }


  let contractSelect = async () => {
    const contractSelectDropDown = document.getElementById("contractSelectDropDown");
    if (!contractSelectDropDown || !contractSelectDropDown.value) {
      alert("Please select a contract first.");
      return;
    }

    const selectedValue = contractSelectDropDown.value;
    const selectedIndex = contractSelectDropDown.selectedIndex;
    const contractName = contractSelectDropDown.options[selectedIndex].text;
    
    setIsChangingContract(true);
    
    try {
      // Update session storage
      sessionStorage.setItem("contract_id", selectedValue);
      sessionStorage.setItem("customer_name", contractName);
      sessionStorage.setItem("impersonate", "1");
      
      // Load contract sites first and update site_ids
      const newSites = await loadContractSites(selectedValue);
      
      // Reset the loaded flags to trigger Dashboard refresh
      sessionStorage.setItem("statsLoaded", "0");
      sessionStorage.setItem("contactsLoaded", "0");
      
      // Small delay to ensure session storage is updated before refresh
      setTimeout(() => {
        window.location.reload();
      }, 100);
      
    } catch (error) {
      console.error("Error changing contract:", error);
      alert("Error changing contract. Please try again.");
      setIsChangingContract(false);
    }
  }



  useEffect(() => {

    // Always load contracts if dropdown is empty or on fresh load
    if (sessionStorage.getItem("contractsLoaded") === "0" || contracts.length === 0) {
      loadContracts();
    }

    if (contractSites.length !== 0) {
      // Ensure contractSites is properly converted to comma-separated string
      const siteIdsString = Array.isArray(contractSites) ? contractSites.join(",") : contractSites;
      sessionStorage.setItem("site_ids", siteIdsString);
    }

    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(sidebar.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
    };
  });

  // Separate useEffect to handle dropdown population when contracts change
  useEffect(() => {
    if (contracts.length > 0) {
      const contractSelectDropDown = document.getElementById("contractSelectDropDown");
      if (contractSelectDropDown !== null) {
        // Clear existing options first
        contractSelectDropDown.innerHTML = '';
        
        // Add default option
        const defaultOption = document.createElement("option");
        defaultOption.text = "Select a contract...";
        defaultOption.value = "";
        contractSelectDropDown.add(defaultOption);

        // Add contract options
        for (let i = 0; i < contracts.length; i++) {
          let option = document.createElement("option");
          option.text = contracts[i].description;
          option.value = contracts[i].id;
          if (sessionStorage.getItem("contract_id") === contracts[i].id) {
            option.selected = true;
          }
          contractSelectDropDown.add(option);
        }
      }
    }
  }, [contracts]);

  // Additional useEffect to ensure dropdown is populated on mount (especially after refresh)
  useEffect(() => {
    // Force load contracts if session indicates they were loaded but state is empty
    if (sessionStorage.getItem("contractsLoaded") === "1" && contracts.length === 0) {
      loadContracts();
    }
  }, []);
  return (
    <div className="sidebar" data-color={props.backgroundColor}>
      <div className="logo">
        <a
          className="simple-text logo-mini"
          target="_blank"
        >
          <div className="logo-img">
            <img src={logo} alt="react-logo" />
          </div>
        </a>
        <a
          className="simple-text logo-normal menuFont"
          target="_blank"
        >
          Customer Portal
        </a>
      </div>
      <div className="sidebar-wrapper" ref={sidebar}>
        <Nav className="menuFont">
          {props.routes.map((prop, key) => {
            if (prop.redirect || prop.hidden === true) return null;
            return (
              <li
                className={
                  activeRoute(prop.layout + prop.path) +
                  (prop.pro ? " active active-pro" : "")
                }
                key={key}
              >
                <NavLink to={prop.layout + prop.path} className="nav-link">
                  <i className={"now-ui-icons " + prop.icon} />
                  <p className="menuFont">{prop.name}</p>
                </NavLink>
              </li>
            );
          })}
        </Nav>
        {sessionStorage.getItem("admin") === "1" &&
          <>
            <hr className="text-white" />

            <div className="dropdown" style={{ padding: "15px", }}>
              <label className="text-white">Admin - View as Contract</label>
              <select className="dropdown-select" style={{ width: "100%", height: "30px", borderRadius: "15px" }} id="contractSelectDropDown" disabled={isChangingContract}>
              </select>
              <NavLink to="/admin/dashboard" onClick={() => contractSelect()} > 
                <Button 
                  color="btn-primary" 
                  style={{ width: "100%", borderRadius: "15px" }}
                  disabled={isChangingContract}
                >
                  {isChangingContract ? "Changing Contract..." : "Change Contract"}
                </Button>
              </NavLink>
            </div>
          </>
        }
      </div>
    </div>
  );
}

export default Sidebar;
